import { render } from "./WatchlistDetails.vue?vue&type=template&id=748e65d4&ts=true"
import script from "./WatchlistDetails.vue?vue&type=script&lang=ts"
export * from "./WatchlistDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__